// extracted by mini-css-extract-plugin
export default {"customButtonContainer":"CustomButton_customButtonContainer__L7JGd"};